module.exports = __webpack_public_path__ + "img/07_shimizu_24.bc0233fc.jpg";